document.addEventListener('DOMContentLoaded', function () {
  var canvas = document.getElementById('particles-canvas');
  if (!canvas) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ctx = canvas.getContext('2d');
  var particles = [];
  var isMobile = window.innerWidth < 700;
  var dustCount = isMobile ? 30 : 60;
  var bokehCount = isMobile ? 10 : 20;

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function makeDust() {
    return {
      type: 'dust',
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 1.8 + 0.5,
      vx: (Math.random() - 0.5) * 0.15,
      vy: -Math.random() * 0.25 - 0.05,
      alpha: Math.random() * 0.4 + 0.15,
      baseAlpha: 0,
      twinkle: Math.random() * 0.02 + 0.005
    };
  }

  function makeBokeh() {
    var baseAlpha = Math.random() * 0.28 + 0.08;
    return {
      type: 'bokeh',
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 26 + 10,
      vx: (Math.random() - 0.5) * 0.08,
      vy: -Math.random() * 0.12 - 0.03,
      alpha: baseAlpha,
      baseAlpha: baseAlpha,
      twinkle: (Math.random() * 0.006 + 0.002) * (Math.random() < 0.5 ? 1 : -1)
    };
  }

  function init() {
    resize();
    particles = [];
    for (var i = 0; i < dustCount; i++) particles.push(makeDust());
    for (var j = 0; j < bokehCount; j++) particles.push(makeBokeh());
  }

  function drawParticle(p) {
    if (p.type === 'bokeh') {
      var grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
      grad.addColorStop(0, 'rgba(232, 205, 138, ' + p.alpha + ')');
      grad.addColorStop(0.6, 'rgba(255, 216, 138, ' + (p.alpha * 0.5) + ')');
      grad.addColorStop(1, 'rgba(255, 216, 138, 0)');
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = grad;
      ctx.fill();
    } else {
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 216, 138, ' + p.alpha + ')';
      ctx.fill();
    }
  }

  function tick() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      if (!prefersReducedMotion) {
        p.x += p.vx;
        p.y += p.vy;

        var min = p.type === 'bokeh' ? p.baseAlpha * 0.3 : 0.1;
        var max = p.type === 'bokeh' ? p.baseAlpha * 1.4 : 0.6;
        p.alpha += p.twinkle;
        if (p.alpha > max || p.alpha < min) p.twinkle *= -1;

        var margin = p.r + 10;
        if (p.y < -margin) {
          p.y = canvas.height + margin;
          p.x = Math.random() * canvas.width;
        }
        if (p.x < -margin) p.x = canvas.width + margin;
        if (p.x > canvas.width + margin) p.x = -margin;
      }

      drawParticle(p);
    }
    if (!prefersReducedMotion) requestAnimationFrame(tick);
  }

  window.addEventListener('resize', resize);
  init();
  tick();
});

(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var aurora = document.querySelector('.aurora-bg');
  if (!aurora) return;

  var ticking = false;

  function updateAurora() {
    var scrollY = window.scrollY || window.pageYOffset;
    var docHeight = Math.max(document.body.scrollHeight - window.innerHeight, 1);
    var progress = Math.min(scrollY / docHeight, 1);

    var parallax = scrollY * 0.15;
    aurora.style.transform = 'translate3d(0, ' + parallax + 'px, 0)';

    var opacity = 0.7 + progress * 0.3;
    aurora.style.opacity = opacity.toFixed(2);

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateAurora);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateAurora();
})();

(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });
})();

(function () {
  var toggle = document.getElementById('MobileMenuToggle');
  var drawer = document.getElementById('MobileMenuDrawer');
  var overlay = document.getElementById('MobileMenuOverlay');
  if (!toggle || !drawer || !overlay) return;

  function openMenu() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  overlay.addEventListener('click', closeMenu);

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 700) closeMenu();
  });
})();

(function () {
  var mainImage = document.getElementById('ProductMainImage');
  var mainImageWrap = document.getElementById('ProductMainImageWrap');
  var thumbBtns = document.querySelectorAll('.product__thumb-btn');

  function setActiveThumb(btn) {
    thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
    if (btn) btn.classList.add('is-active');
  }

  function swapMainImage(fullSrc, alt) {
    if (!mainImage || !fullSrc) return;
    if (mainImageWrap) mainImageWrap.classList.add('is-fading');
    window.setTimeout(function () {
      mainImage.src = fullSrc;
      if (alt) mainImage.alt = alt;
      if (mainImageWrap) mainImageWrap.classList.remove('is-fading');
    }, 150);
  }

  if (mainImage && thumbBtns.length) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fullSrc = btn.getAttribute('data-full');
        var img = btn.querySelector('.product__thumb');
        swapMainImage(fullSrc, img ? img.getAttribute('alt') : null);
        setActiveThumb(btn);
      });
    });
  }

  var zoomBtn = document.getElementById('ProductZoomBtn');
  var lightbox = document.getElementById('ProductLightbox');
  var lightboxImage = document.getElementById('ProductLightboxImage');
  var lightboxClose = document.getElementById('ProductLightboxClose');

  function openLightbox() {
    if (!lightbox || !lightboxImage || !mainImage) return;
    lightboxImage.src = mainImage.src;
    lightboxImage.alt = mainImage.alt;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
  if (mainImageWrap) mainImageWrap.addEventListener('click', openLightbox);
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
})();

(function () {
  var stepper = document.querySelector('.qty-stepper');
  if (!stepper) return;

  var input = stepper.querySelector('.qty-stepper__input');
  var minusBtn = stepper.querySelector('.qty-stepper__btn--minus');
  var plusBtn = stepper.querySelector('.qty-stepper__btn--plus');
  if (!input || !minusBtn || !plusBtn) return;

  function getMin() {
    var min = parseInt(input.getAttribute('min'), 10);
    return isNaN(min) ? 1 : min;
  }

  function getValue() {
    var value = parseInt(input.value, 10);
    return isNaN(value) ? getMin() : value;
  }

  function setValue(value) {
    var min = getMin();
    if (value < min) value = min;
    input.value = value;
    minusBtn.disabled = value <= min;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  minusBtn.addEventListener('click', function () {
    setValue(getValue() - 1);
  });

  plusBtn.addEventListener('click', function () {
    setValue(getValue() + 1);
  });

  input.addEventListener('change', function () {
    minusBtn.disabled = getValue() <= getMin();
  });

  minusBtn.disabled = getValue() <= getMin();
})();

(function () {
  var jsonEl = document.getElementById('ProductVariantsJSON');
  var form = document.getElementById('ProductForm');
  if (!jsonEl || !form) return;

  var variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  var optionGroups = form.querySelectorAll('.pill-group');
  var variantSelect = document.getElementById('ProductVariantSelect');
  var submitBtn = document.getElementById('ProductSubmitButton');
  var priceCurrentEl = document.getElementById('ProductPriceCurrent');
  var priceCompareEl = document.getElementById('ProductPriceCompare');

  function getSelectedOptions() {
    var opts = [];
    optionGroups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-position'), 10) - 1;
      var active = group.querySelector('.pill-btn.is-active');
      opts[position] = active ? active.getAttribute('data-value') : null;
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = true;
      for (var j = 0; j < opts.length; j++) {
        if (variant.options[j] !== opts[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return variant;
    }
    return null;
  }

  function updateUI(variant) {
    if (!variant) return;

    if (variantSelect) {
      variantSelect.value = variant.id;
    }

    if (priceCurrentEl) {
      priceCurrentEl.textContent = variant.price;
    }

    if (priceCompareEl) {
      if (variant.compare_at_price) {
        priceCompareEl.textContent = variant.compare_at_price;
        priceCompareEl.style.display = '';
      } else {
        priceCompareEl.textContent = '';
        priceCompareEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
    }
  }

  optionGroups.forEach(function (group) {
    var hiddenInput = form.querySelector(
      '.product__option-input[data-option-position="' + group.getAttribute('data-option-position') + '"]'
    );
    var pills = group.querySelectorAll('.pill-btn');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        if (hiddenInput) hiddenInput.value = pill.getAttribute('data-value');

        var variant = findVariant(getSelectedOptions());
        updateUI(variant);
      });
    });
  });
})();

/* ===== Pack builder: elegir perfumes del combo con tarjetas ===== */
(function () {
  var builders = document.querySelectorAll('.pack-builder');
  if (!builders.length) return;

  builders.forEach(function (builder) {
    var required = parseInt(builder.getAttribute('data-required'), 10) || 0;
    var slots = builder.querySelectorAll('.pack-slot');
    var cards = builder.querySelectorAll('.pack-card');
    var hiddenInputs = builder.querySelectorAll('.pack-builder__hidden-input');
    var countEl = builder.querySelector('.pack-builder__count');
    var searchInput = builder.querySelector('.pack-builder__search-input');

    function getHiddenInput(slotNum) {
      var match = null;
      hiddenInputs.forEach(function (input) {
        if (input.getAttribute('data-slot') === String(slotNum)) match = input;
      });
      return match;
    }

    function getSlot(slotNum) {
      var match = null;
      slots.forEach(function (slot) {
        if (slot.getAttribute('data-slot') === String(slotNum)) match = slot;
      });
      return match;
    }

    function filledCount() {
      var count = 0;
      hiddenInputs.forEach(function (input) {
        if (input.value) count += 1;
      });
      return count;
    }

    function updateCounter() {
      if (countEl) countEl.textContent = filledCount();
    }

    function findCardByTitle(title) {
      var match = null;
      cards.forEach(function (card) {
        if (card.getAttribute('data-title') === title) match = card;
      });
      return match;
    }

    function firstEmptySlotNum() {
      var found = null;
      hiddenInputs.forEach(function (input) {
        if (!found && !input.value) found = input.getAttribute('data-slot');
      });
      return found;
    }

    function fillSlot(slotNum, title) {
      var input = getHiddenInput(slotNum);
      var slot = getSlot(slotNum);
      if (!input || !slot) return;
      input.value = title;
      slot.classList.add('is-filled');
      slot.querySelector('.pack-slot__label').textContent = title;
      var removeBtn = slot.querySelector('.pack-slot__remove');
      if (removeBtn) removeBtn.hidden = false;
      builder.classList.remove('has-error');
      updateCounter();
    }

    function clearSlot(slotNum) {
      var input = getHiddenInput(slotNum);
      var slot = getSlot(slotNum);
      if (!input || !slot) return;
      var title = input.value;
      input.value = '';
      slot.classList.remove('is-filled');
      slot.querySelector('.pack-slot__label').textContent = 'Elegí un perfume';
      var removeBtn = slot.querySelector('.pack-slot__remove');
      if (removeBtn) removeBtn.hidden = true;
      updateCounter();

      if (title) {
        var card = findCardByTitle(title);
        if (card) card.classList.remove('is-selected');
      }
    }

    function slotNumForTitle(title) {
      var found = null;
      hiddenInputs.forEach(function (input) {
        if (input.value === title) found = input.getAttribute('data-slot');
      });
      return found;
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var title = card.getAttribute('data-title');
        var existingSlot = slotNumForTitle(title);

        if (existingSlot) {
          clearSlot(existingSlot);
          return;
        }

        var emptySlot = firstEmptySlotNum();
        if (!emptySlot) return;

        fillSlot(emptySlot, title);
        card.classList.add('is-selected');
      });
    });

    slots.forEach(function (slot) {
      var removeBtn = slot.querySelector('.pack-slot__remove');
      if (!removeBtn) return;
      removeBtn.addEventListener('click', function () {
        clearSlot(slot.getAttribute('data-slot'));
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        cards.forEach(function (card) {
          var haystack = card.getAttribute('data-search') || '';
          card.classList.toggle('is-hidden', query.length > 0 && haystack.indexOf(query) === -1);
        });
      });
    }
  });

  var form = document.getElementById('ProductForm');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    var invalidBuilder = null;

    builders.forEach(function (builder) {
      if (invalidBuilder) return;
      var required = parseInt(builder.getAttribute('data-required'), 10) || 0;
      var hiddenInputs = builder.querySelectorAll('.pack-builder__hidden-input');
      var filled = 0;
      hiddenInputs.forEach(function (input) {
        if (input.value) filled += 1;
      });
      if (filled < required) invalidBuilder = builder;
    });

    if (invalidBuilder) {
      e.preventDefault();
      invalidBuilder.classList.add('has-error');
      invalidBuilder.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cart__qty').forEach(function (wrapper) {
    var input = wrapper.querySelector('.cart__qty-input');
    var decreaseBtn = wrapper.querySelector('[data-qty-decrease]');
    var increaseBtn = wrapper.querySelector('[data-qty-increase]');
    if (!input) return;

    decreaseBtn.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, value - 1);
    });

    increaseBtn.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || 0;
      input.value = value + 1;
    });
  });
});
